"use strict";

var _regeneratorRuntime = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var cov_hi1ww7bmv = function () {
  var path = "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/file/withFile.js";
  var hash = "3e4e1b5cfbb8c73ad1e0002471f62b4285f71d44";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/file/withFile.js",
    statementMap: {
      "0": {
        start: {
          line: 15,
          column: 8
        },
        end: {
          line: 15,
          column: 13
        }
      },
      "1": {
        start: {
          line: 17,
          column: 29
        },
        end: {
          line: 17,
          column: 43
        }
      },
      "2": {
        start: {
          line: 18,
          column: 34
        },
        end: {
          line: 18,
          column: 44
        }
      },
      "3": {
        start: {
          line: 20,
          column: 20
        },
        end: {
          line: 20,
          column: 33
        }
      },
      "4": {
        start: {
          line: 20,
          column: 26
        },
        end: {
          line: 20,
          column: 33
        }
      },
      "5": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 27,
          column: 5
        }
      },
      "6": {
        start: {
          line: 25,
          column: 6
        },
        end: {
          line: 25,
          column: 37
        }
      },
      "7": {
        start: {
          line: 26,
          column: 6
        },
        end: {
          line: 26,
          column: 49
        }
      },
      "8": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 30,
          column: 5
        }
      },
      "9": {
        start: {
          line: 29,
          column: 6
        },
        end: {
          line: 29,
          column: 31
        }
      },
      "10": {
        start: {
          line: 32,
          column: 23
        },
        end: {
          line: 35,
          column: 5
        }
      },
      "11": {
        start: {
          line: 33,
          column: 6
        },
        end: {
          line: 34,
          column: 27
        }
      },
      "12": {
        start: {
          line: 33,
          column: 18
        },
        end: {
          line: 33,
          column: 33
        }
      },
      "13": {
        start: {
          line: 34,
          column: 11
        },
        end: {
          line: 34,
          column: 27
        }
      },
      "14": {
        start: {
          line: 37,
          column: 25
        },
        end: {
          line: 65,
          column: 5
        }
      },
      "15": {
        start: {
          line: 38,
          column: 21
        },
        end: {
          line: 40,
          column: 7
        }
      },
      "16": {
        start: {
          line: 41,
          column: 6
        },
        end: {
          line: 44,
          column: 8
        }
      },
      "17": {
        start: {
          line: 42,
          column: 8
        },
        end: {
          line: 42,
          column: 20
        }
      },
      "18": {
        start: {
          line: 43,
          column: 8
        },
        end: {
          line: 43,
          column: 59
        }
      },
      "19": {
        start: {
          line: 43,
          column: 35
        },
        end: {
          line: 43,
          column: 59
        }
      },
      "20": {
        start: {
          line: 45,
          column: 6
        },
        end: {
          line: 45,
          column: 56
        }
      },
      "21": {
        start: {
          line: 46,
          column: 6
        },
        end: {
          line: 46,
          column: 36
        }
      },
      "22": {
        start: {
          line: 47,
          column: 6
        },
        end: {
          line: 63,
          column: 7
        }
      },
      "23": {
        start: {
          line: 48,
          column: 8
        },
        end: {
          line: 53,
          column: 10
        }
      },
      "24": {
        start: {
          line: 49,
          column: 10
        },
        end: {
          line: 51,
          column: 12
        }
      },
      "25": {
        start: {
          line: 52,
          column: 10
        },
        end: {
          line: 52,
          column: 25
        }
      },
      "26": {
        start: {
          line: 54,
          column: 8
        },
        end: {
          line: 62,
          column: 9
        }
      },
      "27": {
        start: {
          line: 55,
          column: 27
        },
        end: {
          line: 55,
          column: 87
        }
      },
      "28": {
        start: {
          line: 56,
          column: 10
        },
        end: {
          line: 60,
          column: 11
        }
      },
      "29": {
        start: {
          line: 57,
          column: 12
        },
        end: {
          line: 57,
          column: 29
        }
      },
      "30": {
        start: {
          line: 58,
          column: 12
        },
        end: {
          line: 58,
          column: 25
        }
      },
      "31": {
        start: {
          line: 59,
          column: 12
        },
        end: {
          line: 59,
          column: 63
        }
      },
      "32": {
        start: {
          line: 59,
          column: 39
        },
        end: {
          line: 59,
          column: 63
        }
      },
      "33": {
        start: {
          line: 61,
          column: 10
        },
        end: {
          line: 61,
          column: 25
        }
      },
      "34": {
        start: {
          line: 64,
          column: 6
        },
        end: {
          line: 64,
          column: 25
        }
      },
      "35": {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 67,
          column: 59
        }
      },
      "36": {
        start: {
          line: 67,
          column: 44
        },
        end: {
          line: 67,
          column: 59
        }
      },
      "37": {
        start: {
          line: 69,
          column: 20
        },
        end: {
          line: 69,
          column: 27
        }
      },
      "38": {
        start: {
          line: 70,
          column: 4
        },
        end: {
          line: 72,
          column: 5
        }
      },
      "39": {
        start: {
          line: 71,
          column: 6
        },
        end: {
          line: 71,
          column: 56
        }
      },
      "40": {
        start: {
          line: 74,
          column: 4
        },
        end: {
          line: 74,
          column: 21
        }
      },
      "41": {
        start: {
          line: 77,
          column: 2
        },
        end: {
          line: 117,
          column: 4
        }
      },
      "42": {
        start: {
          line: 119,
          column: 2
        },
        end: {
          line: 119,
          column: 23
        }
      },
      "43": {
        start: {
          line: 122,
          column: 24
        },
        end: {
          line: 122,
          column: 41
        }
      }
    },
    fnMap: {
      "0": {
        name: "withFileComponent",
        decl: {
          start: {
            line: 6,
            column: 9
          },
          end: {
            line: 6,
            column: 26
          }
        },
        loc: {
          start: {
            line: 6,
            column: 38
          },
          end: {
            line: 120,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "FileComponent",
        decl: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 24
          }
        },
        loc: {
          start: {
            line: 7,
            column: 33
          },
          end: {
            line: 75,
            column: 3
          }
        },
        line: 7
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 20,
            column: 20
          },
          end: {
            line: 20,
            column: 21
          }
        },
        loc: {
          start: {
            line: 20,
            column: 26
          },
          end: {
            line: 20,
            column: 33
          }
        },
        line: 20
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 32,
            column: 23
          },
          end: {
            line: 32,
            column: 24
          }
        },
        loc: {
          start: {
            line: 32,
            column: 35
          },
          end: {
            line: 35,
            column: 5
          }
        },
        line: 32
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 37,
            column: 25
          },
          end: {
            line: 37,
            column: 26
          }
        },
        loc: {
          start: {
            line: 37,
            column: 37
          },
          end: {
            line: 65,
            column: 5
          }
        },
        line: 37
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 41,
            column: 21
          },
          end: {
            line: 41,
            column: 22
          }
        },
        loc: {
          start: {
            line: 41,
            column: 27
          },
          end: {
            line: 44,
            column: 7
          }
        },
        line: 41
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 48,
            column: 29
          },
          end: {
            line: 48,
            column: 30
          }
        },
        loc: {
          start: {
            line: 48,
            column: 48
          },
          end: {
            line: 53,
            column: 9
          }
        },
        line: 48
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 54,
            column: 35
          },
          end: {
            line: 54,
            column: 36
          }
        },
        loc: {
          start: {
            line: 54,
            column: 47
          },
          end: {
            line: 62,
            column: 9
          }
        },
        line: 54
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 24,
            column: 4
          },
          end: {
            line: 27,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 24,
            column: 4
          },
          end: {
            line: 27,
            column: 5
          }
        }, {
          start: {
            line: 24,
            column: 4
          },
          end: {
            line: 27,
            column: 5
          }
        }],
        line: 24
      },
      "1": {
        loc: {
          start: {
            line: 28,
            column: 4
          },
          end: {
            line: 30,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 28,
            column: 4
          },
          end: {
            line: 30,
            column: 5
          }
        }, {
          start: {
            line: 28,
            column: 4
          },
          end: {
            line: 30,
            column: 5
          }
        }],
        line: 28
      },
      "2": {
        loc: {
          start: {
            line: 33,
            column: 6
          },
          end: {
            line: 34,
            column: 27
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 33,
            column: 6
          },
          end: {
            line: 34,
            column: 27
          }
        }, {
          start: {
            line: 33,
            column: 6
          },
          end: {
            line: 34,
            column: 27
          }
        }],
        line: 33
      },
      "3": {
        loc: {
          start: {
            line: 43,
            column: 8
          },
          end: {
            line: 43,
            column: 59
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 43,
            column: 8
          },
          end: {
            line: 43,
            column: 59
          }
        }, {
          start: {
            line: 43,
            column: 8
          },
          end: {
            line: 43,
            column: 59
          }
        }],
        line: 43
      },
      "4": {
        loc: {
          start: {
            line: 47,
            column: 6
          },
          end: {
            line: 63,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 47,
            column: 6
          },
          end: {
            line: 63,
            column: 7
          }
        }, {
          start: {
            line: 47,
            column: 6
          },
          end: {
            line: 63,
            column: 7
          }
        }],
        line: 47
      },
      "5": {
        loc: {
          start: {
            line: 56,
            column: 10
          },
          end: {
            line: 60,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 56,
            column: 10
          },
          end: {
            line: 60,
            column: 11
          }
        }, {
          start: {
            line: 56,
            column: 10
          },
          end: {
            line: 60,
            column: 11
          }
        }],
        line: 56
      },
      "6": {
        loc: {
          start: {
            line: 59,
            column: 12
          },
          end: {
            line: 59,
            column: 63
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 59,
            column: 12
          },
          end: {
            line: 59,
            column: 63
          }
        }, {
          start: {
            line: 59,
            column: 12
          },
          end: {
            line: 59,
            column: 63
          }
        }],
        line: 59
      },
      "7": {
        loc: {
          start: {
            line: 67,
            column: 4
          },
          end: {
            line: 67,
            column: 59
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 67,
            column: 4
          },
          end: {
            line: 67,
            column: 59
          }
        }, {
          start: {
            line: 67,
            column: 4
          },
          end: {
            line: 67,
            column: 59
          }
        }],
        line: 67
      },
      "8": {
        loc: {
          start: {
            line: 67,
            column: 8
          },
          end: {
            line: 67,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 67,
            column: 8
          },
          end: {
            line: 67,
            column: 18
          }
        }, {
          start: {
            line: 67,
            column: 22
          },
          end: {
            line: 67,
            column: 30
          }
        }, {
          start: {
            line: 67,
            column: 34
          },
          end: {
            line: 67,
            column: 42
          }
        }],
        line: 67
      },
      "9": {
        loc: {
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 72,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 72,
            column: 5
          }
        }, {
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 72,
            column: 5
          }
        }],
        line: 70
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0, 0],
      "9": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "3e4e1b5cfbb8c73ad1e0002471f62b4285f71d44"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withFile = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _helpers = require("./helpers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function withFileComponent(Component) {
  cov_hi1ww7bmv.f[0]++;

  function FileComponent(props) {
    cov_hi1ww7bmv.f[1]++;

    var _ref = (cov_hi1ww7bmv.s[0]++, props),
        authentication = _ref.authentication,
        repository = _ref.repository,
        blob = _ref.blob,
        file = _ref.file,
        onFile = _ref.onFile,
        fileConfig = _ref.fileConfig;

    var _ref2 = (cov_hi1ww7bmv.s[1]++, (0, _react.useState)(file)),
        _ref3 = _slicedToArray(_ref2, 2),
        _file = _ref3[0],
        setFile = _ref3[1];

    var _ref4 = (cov_hi1ww7bmv.s[2]++, (0, _react.useState)()),
        _ref5 = _slicedToArray(_ref4, 2),
        deleted = _ref5[0],
        setDeleted = _ref5[1];

    cov_hi1ww7bmv.s[3]++;

    var hasFile = function hasFile() {
      cov_hi1ww7bmv.f[2]++;
      cov_hi1ww7bmv.s[4]++;
      return !!_file;
    };

    var filepath, defaultContent;
    cov_hi1ww7bmv.s[5]++;

    if (fileConfig) {
      cov_hi1ww7bmv.b[0][0]++;
      cov_hi1ww7bmv.s[6]++;
      filepath = fileConfig.filepath;
      cov_hi1ww7bmv.s[7]++;
      defaultContent = fileConfig.defaultContent;
    } else {
      cov_hi1ww7bmv.b[0][1]++;
    }

    cov_hi1ww7bmv.s[8]++;

    if (blob) {
      cov_hi1ww7bmv.b[1][0]++;
      cov_hi1ww7bmv.s[9]++;
      filepath = blob.filepath;
    } else {
      cov_hi1ww7bmv.b[1][1]++;
    }

    cov_hi1ww7bmv.s[10]++;

    var updateFile = function updateFile(__file) {
      cov_hi1ww7bmv.f[3]++;
      cov_hi1ww7bmv.s[11]++;

      if (onFile) {
        cov_hi1ww7bmv.b[2][0]++;
        cov_hi1ww7bmv.s[12]++;
        onFile(__file);
      } else {
        cov_hi1ww7bmv.b[2][1]++;
        cov_hi1ww7bmv.s[13]++;
        setFile(__file);
      }
    };

    cov_hi1ww7bmv.s[14]++;

    var populateFile = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var __file;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                cov_hi1ww7bmv.f[4]++;
                cov_hi1ww7bmv.s[15]++;
                _context3.next = 4;
                return (0, _helpers.ensureFile)({
                  filepath: filepath,
                  defaultContent: defaultContent,
                  authentication: authentication,
                  config: fileConfig,
                  repository: repository
                });

              case 4:
                __file = _context3.sent;
                cov_hi1ww7bmv.s[16]++;

                __file.close = function () {
                  cov_hi1ww7bmv.f[5]++;
                  cov_hi1ww7bmv.s[17]++;
                  updateFile();
                  cov_hi1ww7bmv.s[18]++;

                  if (fileConfig.updateBlob) {
                    cov_hi1ww7bmv.b[3][0]++;
                    cov_hi1ww7bmv.s[19]++;
                    fileConfig.updateBlob();
                  } else {
                    cov_hi1ww7bmv.b[3][1]++;
                  }
                };

                cov_hi1ww7bmv.s[20]++;
                _context3.next = 10;
                return (0, _helpers.getContentFromFile)(__file);

              case 10:
                __file.content = _context3.sent;
                cov_hi1ww7bmv.s[21]++;
                __file.filepath = __file.path;
                cov_hi1ww7bmv.s[22]++;

                if (repository.permissions.push) {
                  cov_hi1ww7bmv.b[4][0]++;
                  cov_hi1ww7bmv.s[23]++;

                  __file.saveContent = /*#__PURE__*/function () {
                    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(content) {
                      return _regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              cov_hi1ww7bmv.f[6]++;
                              cov_hi1ww7bmv.s[24]++;
                              _context.next = 4;
                              return (0, _helpers.saveContent)({
                                content: content,
                                authentication: authentication,
                                repository: repository,
                                file: __file
                              });

                            case 4:
                              cov_hi1ww7bmv.s[25]++;
                              populateFile();

                            case 6:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    }));

                    return function (_x) {
                      return _ref7.apply(this, arguments);
                    };
                  }();

                  cov_hi1ww7bmv.s[26]++;
                  __file.dangerouslyDelete = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                    var _deleted;

                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            cov_hi1ww7bmv.f[7]++;
                            cov_hi1ww7bmv.s[27]++;
                            _context2.next = 4;
                            return (0, _helpers.deleteFile)({
                              authentication: authentication,
                              repository: repository,
                              file: __file
                            });

                          case 4:
                            _deleted = _context2.sent;
                            cov_hi1ww7bmv.s[28]++;

                            if (_deleted) {
                              cov_hi1ww7bmv.b[5][0]++;
                              cov_hi1ww7bmv.s[29]++;
                              setDeleted(true);
                              cov_hi1ww7bmv.s[30]++;
                              updateFile();
                              cov_hi1ww7bmv.s[31]++;

                              if (fileConfig.updateBlob) {
                                cov_hi1ww7bmv.b[6][0]++;
                                cov_hi1ww7bmv.s[32]++;
                                fileConfig.updateBlob();
                              } else {
                                cov_hi1ww7bmv.b[6][1]++;
                              }
                            } else {
                              cov_hi1ww7bmv.b[5][1]++;
                            }

                            cov_hi1ww7bmv.s[33]++;
                            return _context2.abrupt("return", deleted);

                          case 9:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));
                } else {
                  cov_hi1ww7bmv.b[4][1]++;
                }

                cov_hi1ww7bmv.s[34]++;
                updateFile(__file);

              case 17:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function populateFile() {
        return _ref6.apply(this, arguments);
      };
    }();

    cov_hi1ww7bmv.s[35]++;

    if ((cov_hi1ww7bmv.b[8][0]++, !hasFile()) && (cov_hi1ww7bmv.b[8][1]++, filepath) && (cov_hi1ww7bmv.b[8][2]++, !deleted)) {
      cov_hi1ww7bmv.b[7][0]++;
      cov_hi1ww7bmv.s[36]++;
      populateFile();
    } else {
      cov_hi1ww7bmv.b[7][1]++;
    }

    var component = (cov_hi1ww7bmv.s[37]++, _react.default.createElement("div", null));
    cov_hi1ww7bmv.s[38]++;

    if (hasFile()) {
      cov_hi1ww7bmv.b[9][0]++;
      cov_hi1ww7bmv.s[39]++;
      component = _react.default.createElement(Component, _extends({}, props, {
        file: _file
      }));
    } else {
      cov_hi1ww7bmv.b[9][1]++;
    }

    cov_hi1ww7bmv.s[40]++;
    return component;
  }

  cov_hi1ww7bmv.s[41]++;
  FileComponent.propTypes = {
    /** The full filepath for the file. */
    filepath: _propTypes.default.string,

    /** Pass a previously returned file object to bypass the selection. */
    file: _propTypes.default.shape({
      name: _propTypes.default.string.isRequired,
      path: _propTypes.default.string.isRequired,
      sha: _propTypes.default.string.isRequired,
      download_url: _propTypes.default.string.isRequired,
      content: _propTypes.default.string.isRequired
    }),

    /** Function to propogate when the Blob is selected. */
    onFile: _propTypes.default.func,

    /** Pass a blob object. */
    blob: _propTypes.default.shape({
      /** The full filepath generated in the Tree/Blob Object */
      filepath: _propTypes.default.string.isRequired
    }),

    /** Function to propogate when the Blob is selected. */
    onEdit: _propTypes.default.func,

    /** Authentication object returned from a successful withAuthentication login. */
    authentication: _propTypes.default.shape({
      config: _propTypes.default.shape({
        server: _propTypes.default.string.isRequired,
        headers: _propTypes.default.shape({
          Authorization: _propTypes.default.string.isRequired
        }).isRequired
      }).isRequired,
      user: _propTypes.default.shape({
        username: _propTypes.default.string.isRequired,
        email: _propTypes.default.string.isRequired
      }).isRequired
    }),

    /** Repository tree_url can be used in place of blobConfig */
    repository: _propTypes.default.shape({
      owner: _propTypes.default.shape({
        username: _propTypes.default.string.isRequired
      }),
      name: _propTypes.default.string.isRequired
    }).isRequired
  };
  cov_hi1ww7bmv.s[42]++;
  return FileComponent;
}

var withFile = (cov_hi1ww7bmv.s[43]++, withFileComponent);
exports.withFile = withFile;